import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const AdDeleted = ({ width = '64px', height = '64px', fill = '#EBEBEB' }) => (React__default.createElement(SvgImg, { width: width, height: height, viewbox: "0 0 64 64", title: "ome" },
    React__default.createElement("rect", { width: "64", height: "64", rx: "2", fill: fill }),
    React__default.createElement("path", { d: "M37.5 27.2265L36.7735 26.5L32 31.2735L27.2265 26.5L26.5 27.2265L31.2735 32L26.5 36.7735L27.2265 37.5L32 32.7265L36.7735 37.5L37.5 36.7735L32.7265 32L37.5 27.2265Z", fill: "#9C9C9C" })));

export { AdDeleted };
